import richTextEditorSelectionMaskTemplate from '../../templates/stories/richTextEditorSelectionMask.hbs';
import $ from 'jquery';
import _ from 'lodash';
import {forEachObjIndexed, pathOr} from 'ramda';
const $doc = $(document);
const $win = $(window);

// chrome needs to use the selectionchange event to capture keyboard selections ex ctr+A to select all.
// unfortunately, toggling/moving the menu on that event results in a choppy experience. we'll throttle it with
// a custom event. firefox doesn't support selectionchange so we'll shim in a similar event here.

$.event.special.selectionstop = (function() {
    let timer;

    const trigger = function() {
        $doc.trigger('selectionstop');
    };
    const timedTrigger = function() {
        clearTimeout(timer);
        timer = setTimeout(trigger, 200);
    };
    const selectionstop = {};

    if (document.hasOwnProperty('onselectionchange')) {
        selectionstop.setup = function() {
            $doc.on('selectionchange', timedTrigger);
        };
        selectionstop.teardown = function() {
            $doc.off('selectionchange', timedTrigger);
        };
    } else {
        selectionstop.setup = function() {
            $doc.on('click', trigger)
                .on('keyup', trigger)
                .on('mouseup', trigger);
        };
        selectionstop.teardown = function() {
            $doc.off('click', trigger)
                .off('keyup', trigger)
                .off('mouseup', trigger);
        };
    }
    return selectionstop;
})();

const $$ = {
    //  DOM Utilities

    blockEl: 'p, h2, ul, ol, blockquote',
    emptyEl: $(),
    p: $('<p/>'),
    div: $('<div/>'),

    el(tagName) {
        return $('<' + tagName + '/>');
    },

    getBlockParent($el, $parent) {
        return $el.is(this.blockEl) ? $el : $el.parentsUntil($parent, this.blockEl).first();
    },

    isTextNode($el) {
        const el = $el && $el.jquery ? $el[0] : $el;
        return typeof el !== 'undefined' && el !== null && el.nodeType === 3;
    },

    getTextNodes($el) {
        return $el.contents().filter(function() {
            return this.nodeType === 3;
        });
    },

    replaceWithContents() {
        return $(this).html();
    },

    toHTML(text) {
        const $container = $$.div.clone();
        const $p = $$.p.clone();
        const linebreak = /(\r|\n)/;

        if (!linebreak.test(text)) {
            return text;
        }
        text.split(linebreak).forEach(function(txt) {
            txt = txt.trim();
            if (txt) {
                $p.clone()
                    .text(txt)
                    .appendTo($container);
            }
        });

        return $container.html();
    },
};

function UserSelection($editor) {
    this.$editor = $editor;
    this.$scrollableContainer = null;
}

UserSelection.prototype = {
    getFirstLineCoordinates() {
        // note: IE mobile doesn't support getClientRects
        const rects = _.toArray(this.range.getClientRects());

        // when a list is selected, chrome returns the width of the window in the first rect coords
        if (
            this.$els.length === 1 &&
            this.$els.is('ul, ol') &&
            rects[0].width === this.$editor.width() - 80 &&
            rects.length > 1
        ) {
            rects.shift();
        }

        const editorTop = this.$editor.offset().top;
        // first rect in viewport
        const firstRect = _.find(rects, function(rect) {
            return rect.bottom > editorTop;
        });

        if (!firstRect) {
            return false;
        }

        const returnObj = {
            top: firstRect.top,
            left: firstRect.left,
            width: 0,
        };

        // get all rects on same line
        const sameLineRects = _.filter(rects, function(rect) {
            return rect.top === firstRect.top;
        });

        _.each(sameLineRects, function(rect) {
            returnObj.width += rect.width;
        });

        return returnObj;
    },

    hasSelection() {
        return this.$els.text().length > 0;
    },

    getSelectedElements() {
        const $editor = this.$editor,
            selection = this.selection;
        let $els = $(this.range.commonAncestorContainer).find('*'),
            reset = false;

        // limit selection to elements in the editor
        $els = $els.filter(function() {
            return selection.containsNode(this, true) && ($editor.has(this).length > 0 || $editor.is(this));
        });

        const $first = $els.first(),
            $last = $els.last();

        if (!$first.is(this.$start) && $$.isTextNode($first)) {
            this.startOffset = 0;
            reset = true;
        }

        if (!$last.is(this.$end) && $$.isTextNode($last)) {
            this.endOffset = $last.text().length;
            reset = true;
        }

        if ($els.length > 0 && reset) {
            this.reset();
        }

        return $els;
    },

    getSelectedElementsByTag(parentTag) {
        const parents = this.$start.parentsUntil(this.$editor).filter(parentTag);
        return this.$els.add(parents);
    },

    getElements() {
        this.$els = $();

        if (this.$start.is(this.$end)) {
            // just one element selected

            if (this.$editor.has(this.$start).length > 0 || this.$start.is(this.$editor)) {
                this.$els = this.$els.add(this.$start);
            }
        } else {
            this.$els = this.$els.add(this.getSelectedElements());
        }
        this.getBlockElements();
        return this;
    },

    getBlockElements() {
        let $start = '',
            $end = '',
            $blocks = $$.emptyEl.clone();
        if (this.$els.length) {
            $start = $$.getBlockParent(this.$start, this.$editor);
            $end = $$.getBlockParent(this.$end, this.$editor);
            $blocks = $start.is($end) ? $start : $start.add($start.nextUntil($end)).add($end);
        }
        this.$blockEls = $blocks;
    },

    reset(range) {
        const selection = this.selection || window.getSelection();
        const _range = range || this.range || selection.getRangeAt(0);
        selection.removeAllRanges();
        selection.addRange(_range);
        this.update();
    },

    selectEls($start, $end) {
        if (!$start || !$start.jquery || !$start.length) {
            return false;
        }
        const range = document.createRange();

        if ($end && $end.length && $end.jquery) {
            const endOffset = $$.isTextNode($end) ? $end.text().length : $end.contents().length;
            range.setStart($start[0], 0);
            range.setEnd($end[0], endOffset);
        } else {
            range.selectNode($start[0]);
        }
        return this.reset(range);
    },

    selectBlock() {
        this.selectEls(this.$blockEls.first(), this.$blockEls.last());
    },

    update(selection) {
        this.selection = selection || window.getSelection();

        const parentNode = pathOr({}, ['selection', 'baseNode', 'parentNode'], this);
        parentNode.normalize && parentNode.normalize();

        if (this.selection.rangeCount) {
            this.range = this.selection.getRangeAt(0);
            this.$start = $(this.range.startContainer);
            this.startOffset = this.range.startOffset;
            this.$end = $(this.range.endContainer);
            this.endOffset = this.range.endOffset;
            return this.getElements();
        } else {
            this.$els = $$.emptyEl.clone();
            return this;
        }
    },
};

const tokenize = input => input.split(/\s+/g);

const addListener = ($target, eventName, contextSelector, callback) =>
    contextSelector.length > 0 ? $target.on(eventName, contextSelector, callback) : $target.on(eventName, callback);

export function StoryEditor(el) {
    this.$el = $(el);
    return this.init();
}

StoryEditor.prototype = {
    events: {
        keyup: 'keyupHandler',
        escapeKey: 'hideSelectionMenu',
        'escapeKey menu .sda-editor-link .fa-times': 'hideSelectionMenu',
        'escapeKey .sda-editor-linkField': 'hideSelectionMenu',

        'focus .sda-editor-content': 'addDocumentListeners',
        'focus .sda-editor-link input': 'addSelectionMask',

        'blur .sda-editor-content': 'removeDocumentListeners',
        'blur .sda-editor-linkField': 'toggleLink',

        'deleteKey .sda-editor-content': 'deleteKeyHandler',

        'keypress .sda-editor-content': 'insertParagraph',

        'enterKey .sda-editor-link': 'toggleLink',
        'enterKey .sda-editor-content': 'enterKeyHandler',
        'enterKey menu .sda-editor-link .fa-times': 'clearLink',

        'mousedown .sda-editor-mask': 'removeSelectionMask',

        'click menu .sda-editor-link .fa-times': 'clearLink',
        'click .sda-editor-selection[data-show="tags"]': 'selectionButtonHandler',
        'click menu [data-tag]': 'insertTag',
        'click menu [data-link]': 'showLinkMenu',
        'click menu [data-block]': 'insertBlock',
    },

    keyEvents: {
        8: 'deleteKey',
        13: 'enterKey',
        27: 'escapeKey',
        46: 'deleteKey',
    },

    state: 'editText', // editText, selectMenu (eventually inputMenu)

    //  other properties:
    //    $edit
    //    $selectionMenu
    //      $selectionMenu.width, $selectionMenu.height
    //    $formatTags
    //    $link
    //    $menuArrow
    //    userSelection = new UserSelection(this.$edit)
    //    maxRight

    setState(state) {
        this.$el.attr('data-state', state);
        this.state = state;
    },

    deleteKeyHandler() {
        // Check if we need an additional paragraph
        if (this.editorIsEmpty() || this.lastElementIsEmbed()) {
            this.insertEmptyParagraph();
        }
    },

    lastElementIsEmbed() {
        const lastChild = this.$edit.children().last();
        return lastChild.find('sd-embed').length !== 0 || lastChild.is('sd-embed');
    },

    editorIsEmpty() {
        return this.$edit.html().length <= 0;
    },

    insertEmptyParagraph() {
        const $p = $('<p></p>').appendTo(this.$edit);
        this.userSelection.selectEls($p);
    },

    // region DOM EVENT HANDLERS

    keyupHandler(e) {
        const keyEvent = this.keyEvents[e.keyCode];
        if (keyEvent) {
            $(e.target).trigger(keyEvent, e);
        }
    },

    enterKeyHandler() {
        // sometimes chrome insists on inserting a div
        const $el = $(window.getSelection().getRangeAt(0).endContainer);
        if ($el.is('div')) {
            document.execCommand('formatBlock', false, 'p');
        }
    },

    insertParagraph(e) {
        // ensure that paragraphs are inserted when pressing enter at
        // the end of a blockquote, heading or list
        if (e.keyCode !== 13) {
            return;
        }
        const range = window.getSelection().getRangeAt(0);
        const blockEls = 'div, blockquote, h2, li:last-child';
        const $el = $(range.endContainer);
        const $blockEl = $el.is(blockEls) ? $el : $el.parentsUntil(this.$edit, blockEls).first();
        let isLastChar = false;
        if ($$.isTextNode($el)) {
            isLastChar = $el[0].length === range.endOffset && $el.next().length === 0 && !$blockEl.is('li');
        } else {
            isLastChar = $blockEl.length && $blockEl.text().length === 0;
        }
        if (isLastChar) {
            if ($blockEl.is('h2, blockquote, li')) {
                e.preventDefault();
                document.execCommand('insertParagraph');
                document.execCommand('formatBlock', false, 'p');
            } else if ($blockEl.is('div')) {
                e.preventDefault();
                document.execCommand('formatBlock', false, 'p');
                document.execCommand('insertParagraph');
            }
        }
    },

    resizeHandler() {
        this.maxRight = this.$el.width();
        this.$edit._width = parseInt(this.$edit.css('width').slice(0, -2), 10);
        if (this.state === 'selectMenu') {
            this.positionSelectionMenu();
        }
    },

    pasteHandler(evt) {
        const data = evt.originalEvent.clipboardData;
        let text = data.getData('text/plain') || '';

        // should be coming from $editor
        evt.preventDefault();
        text = text.replace(/<[^>]*>/gi, ''); // strip html
        document.execCommand('insertHTML', false, $$.toHTML(text));
    },

    // endregion DOM EVENT HANDLERS
    // region FORMATTING MENU

    selectionButtonHandler() {
        this.userSelection.reset();
    },

    toggleSelectionMenu(e) {
        const selection = window.getSelection();
        this.userSelection.reset(window.getSelection().getRangeAt(0));
        if (!selection.isCollapsed && this.userSelection.update(selection).hasSelection()) {
            // valid selection
            if (this.detectLinkOnlyMode()) {
                const link = this.userSelection.getSelectedElementsByTag('a').filter('a[href]');
                if (link.length > 0) {
                    this.toggleRemoveLinkButton(false);
                } else {
                    this.toggleRemoveLinkButton(true);
                }
                this.toggleLinkButton(false);
            } else if (this.state === 'editText') {
                this.showSelectionMenu(e);
            } else {
                this.positionSelectionMenu();
            }
        } else if (selection.isCollapsed && this.state === 'selectionMenu') {
            this.hideSelectionMenu();
        } else {
            this.hideLinkMenu();
        }
    },

    showSelectionMenu(e, urlFormat = '') {
        const $selectionMenu = this.$selectionMenu;
        this.urlFormat = urlFormat;
        this.setState('selectionMenu');
        this.positionSelectionMenu();
        window.setTimeout(function() {
            $selectionMenu.css('transition-property', 'opacity, left, top');
        }, 255);
        if (this.detectLinkOnlyMode()) {
            this.showLinkMenu(e);
        }
    },

    hideSelectionMenu() {
        this.setState('editText');
        this.$selectionMenu.css('transition-property', 'opacity');
        this.hideLinkMenu();
    },

    positionSelectionMenu() {
        const firstLinePos = this.userSelection.getFirstLineCoordinates();
        const menuWidth = this.$selectionMenu._width || this.$selectionMenu.width();

        if (!firstLinePos) {
            // no selections in viewport
            this.hideSelectionMenu();
        } else {
            const menuTop = firstLinePos.top - this.$selectionMenu._height;

            this.maxRight = this.findMaxRight();
            firstLinePos.center = firstLinePos.left + firstLinePos.width / 2;
            let menuLeft = firstLinePos.center - menuWidth / 2;
            // ensure position is between the minLeft and maxRight
            menuLeft = Math.min(this.maxRight - menuWidth, Math.max(0, menuLeft));
            let arrowLeft = firstLinePos.center - menuLeft - 9;
            arrowLeft = Math.min(menuWidth - 18, Math.max(0, arrowLeft));

            this.$selectionMenu.css({top: menuTop, left: menuLeft});
            this.$menuArrow.css('left', arrowLeft);
            this.removeSelectionMask();
        }
    },

    insertTag(evt) {
        evt.stopImmediatePropagation();

        const command = $(evt.target).attr('data-tag');
        this.userSelection.reset();
        document.execCommand(command, false, null);
        this.userSelection.update();
    },

    insertBlock(evt) {
        const tag = $(evt.target).attr('data-block');
        const isList = tag === 'ol' || tag === 'ul';
        const $container = $$.div.clone().html(this.userSelection.$blockEls.clone());
        const blocks = $$.blockEl + ', li';
        const $blockEls = this.userSelection.$blockEls;
        const alreadyTag = $container.children().length === $container.children(tag).length;
        let insertionTag, children;

        evt.stopPropagation();
        evt.preventDefault();

        this.userSelection.reset();
        this.userSelection.selectBlock();

        $container.find('ul, ol').replaceWith($$.replaceWithContents);
        $container
            .children()
            .find($$.blockEl)
            .replaceWith($$.replaceWithContents);
        // keep track of selection points
        children = this.$edit.children();
        const startIndex = children.index($blockEls.first());
        let endIndex = children.index($blockEls.last());

        if (alreadyTag) {
            // replace with paragraphs
            insertionTag = $$.p;
        } else {
            insertionTag = isList ? 'li' : tag;
            insertionTag = $$.el(insertionTag);
        }

        $container.find(blocks).replaceWith(function() {
            return insertionTag.clone().html($(this).html());
        });

        if (isList && !alreadyTag) {
            $container.wrapInner($$.el(tag));
            endIndex = startIndex;
        } else if (isList) {
            endIndex = startIndex + $container.find(blocks).length - 1;
        }

        // execCommand insertHTML, insertOrdered list etc does weird things in Chrome
        $blockEls.not(':first').remove();
        $blockEls.replaceWith($container.html());
        // reset selection
        children = this.$edit.children();
        this.userSelection.selectEls(children.eq(startIndex), children.eq(endIndex));
    },

    /*
     * enable & disable link button in media tab when there is a selection
     */
    toggleLinkButton(disable) {
        if (this.detectLinkOnlyMode()) {
            this.$el
                .parent()
                .find('.create-link-btn')
                .prop('disabled', disable);
        }
    },

    toggleRemoveLinkButton(disable) {
        if (this.detectLinkOnlyMode()) {
            this.$el
                .parent()
                .find('.remove-link-btn')
                .prop('disabled', disable);
        }
    },

    showLinkMenu(evt) {
        const link = this.userSelection
            .getSelectedElementsByTag('a')
            .filter('a[href]')
            .attr('href');
        this.$errorTool.css('display', 'none');
        if (link) {
            this.$link.val(link.trim());
        }

        this.$selectionMenu.attr('data-show', 'link');
        if ('displayRemoveLinkField' === event.target.parentElement.dataset.action) {
            this.$link.prop('disabled', true);
            this.$clearLink.css('display', 'block');
            this.$clearLink.focus();
        } else {
            this.$link.prop('disabled', false);
            this.$clearLink.css('display', 'none');
            this.$link.focus();
        }

        evt.stopPropagation();
    },

    hideLinkMenu() {
        this.$selectionMenu.attr('data-show', 'tags');
        this.$link.val('');
        this.toggleLinkButton(true);
        this.toggleRemoveLinkButton(true);
        this.removeSelectionMask();
    },

    constructLink(link) {
        document.execCommand('createLink', false, link);
        this.$edit
            .find(`[href="${link}"]`)
            .prop('title', link)
            .prop('target', '_blank');
    },

    removeLink() {
        document.execCommand('unlink', false, null);
    },

    clearLink() {
        this.userSelection.reset();
        this.removeLink();
        this.userSelection.rest(new Range());
        this.hideSelectionMenu();
    },

    validateURL(link) {
        const status = link.match(this.urlFormat);

        if (!status) {
            this.$errorTool.css('display', 'block');
        } else {
            this.$errorTool.css('display', 'none');
        }
        return status;
    },

    toggleLink() {
        const link = this.$link.val().trim();

        if (!link || link.length <= 0 || this.validateURL(link)) {
            this.userSelection.reset();

            if (link) {
                this.constructLink(link);
            }
            this.userSelection.update();
            this.hideSelectionMenu();
            this.userSelection.reset(new Range());
        }
    },

    addSelectionMask() {
        const html = document.createDocumentFragment();
        const rects = _.toArray(this.userSelection.range.getClientRects());
        const offsets = this.$el.offset();

        $('.sda-editor-mask').remove();
        _.each(rects, rect => {
            $(
                richTextEditorSelectionMaskTemplate({
                    top: rect.top - offsets.top,
                    left: rect.left - offsets.left,
                    width: rect.width,
                    height: rect.height,
                }),
            ).appendTo(html);
        });
        this.$el.append(html);
    },

    removeSelectionMask() {
        this.$el.find('.sda-editor-mask').remove();
        if (this.detectLinkOnlyMode()) {
            this.toggleLinkButton(true);
            this.toggleRemoveLinkButton(true);
        }
    },

    // endregion FORMATTING MENU
    // region INIT

    addListeners() {
        const toFunction = input => ('function' === typeof input ? input : this[input]);

        forEachObjIndexed((val, key) => {
            const callback = toFunction(val);
            if (callback) {
                const [eventType, ...selectors] = tokenize(key);
                addListener(this.$el, eventType, selectors.join(' '), e => callback.call(this, e));
            }
        }, this.events);

        // ensure listeners cleaned up when the user leaves the page
        $win.one('haschange.sda-editor', this.removeDocumentListeners.bind(this));

        if (this.$edit.is(':focus')) {
            this.addDocumentListeners();
        }
    },

    getContents() {
        const $clone = $(this.$edit).clone();

        $.each($clone.find('sd-embed'), function() {
            $(this).empty();
        });

        return $clone.html();
    },

    addDocumentListeners() {
        this.removeDocumentListeners();
        $doc.on('selectionstop.sda-editor', this.toggleSelectionMenu.bind(this));
        $win.on('resize.sda-editor', this.resizeHandler.bind(this)).on(
            'paste.sda-editor',
            this.pasteHandler.bind(this),
        );
    },

    removeDocumentListeners() {
        $doc.off('.sda-editor');
        $win.off('.sda-editor');
    },

    getMenuDimensions() {
        // we need dimensions of the menu to display them in the proper position.
        // their sizes shouldn't change so cache so we don't have to do frequent dom lookups
        const width = this.$selectionMenu.width();
        const topOffset = 11; // how far from top of selection should the arrow be
        this.$selectionMenu._width = width;
        this.$selectionMenu._height = this.$selectionMenu.height() + topOffset;
        this.$edit._width = parseInt(this.$edit.css('width').slice(0, -2), 10);
        this.maxRight = this.findMaxRight();
    },

    getElements() {
        this.$edit = this.$el.find('> .sda-editor-content');
        this.$selectionMenu = this.$el.find('menu.sda-editor-selection');
        this.$formatTags = this.$selectionMenu.find(' > .sda-editor-tags');
        this.$link = this.$selectionMenu.find('> .sda-editor-link input');
        this.$clearLink = this.$selectionMenu.find('> .sda-editor-link button');
        this.$menuArrow = this.$selectionMenu.find('> figure');
        this.$errorTool = this.$selectionMenu.find('> .sda-editor-link .error-panel');
        this.userSelection = new UserSelection(this.$edit);
    },

    findMaxRight() {
        return this.$el.offset().left + this.$el.width();
    },

    /*
     * search for data attribute 'data-link-only-mode'
     * to show the link or selection menu
     */
    detectLinkOnlyMode() {
        return this.$el[0].hasAttribute('data-link-only-mode');
    },

    init() {
        this.getElements();
        this.getMenuDimensions();
        this.addListeners();
        this.detectLinkOnlyMode();
        this.$el.data('sdaEditor', this);

        return this;
    },

    // endregion INIT
};

$.fn.sdaEditor = function() {
    return this.each(index => new StoryEditor(this.get(index)));
};
